import { Action } from 'redux';

import { EnterFlowSubspace } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { FlowSubspaceName } from '../../app/state/SpaceInfo';
import { FlowDetailWithUsageInfo } from '../../ts/models/FlowInfo';

export interface EnterFlowSubspaceReduxAction extends Action {
  readonly flowDetailInfo: FlowDetailWithUsageInfo;
  readonly subspaceName: FlowSubspaceName;
}

export function enterFlowSubspace(
  flowDetailInfo: FlowDetailWithUsageInfo,
  subspaceName: FlowSubspaceName,
): EnterFlowSubspaceReduxAction {
  return {
    type: EnterFlowSubspace,
    flowDetailInfo,
    subspaceName,
  };
}

export const isEnterFlowSubspaceAction = isActionFactory<EnterFlowSubspaceReduxAction>(EnterFlowSubspace);
